import React from "react";
import PropTypes from "prop-types";

// context
import { useDropDown } from "../useDropDown";

// components
import { UnstyledButton } from "core/Button/styles.js";

// component
export const Hotspot = ({ className, children, ...rest }) => {
    const { toggleIsOpen, id, isOpen, isDisabled } = useDropDown();

    const onKeyDown = e => {
        if (e.key === "Enter") {
            e.preventDefault();
            toggleIsOpen(true);
        }
    };

    return (
        <UnstyledButton
            className={className}
            onClick={toggleIsOpen}
            onKeyDown={onKeyDown}
            id={`${id}-dropdown-trigger`}
            aria-haspopup="menu"
            aria-expanded={isOpen ? "true" : "false"}
            aria-controls={`${id}-dropdown-panel`}
            disabled={isDisabled}
            {...rest}
        >
            {children}
        </UnstyledButton>
    );
};

export default Hotspot;

// prop-types
Hotspot.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any
};
